<template>
    <div>
        <div class="main-inner">
            <div class="row align-items-center mb-3">
                <div class="col-12 col-md-12">
                    <h1 class="mb-0">Object: {{ property.street }} {{ property.housenumber ? property.housenumber : '' + property.housenumber_addition }}, {{ property.city }}</h1>
                </div>
            </div>

            <div class="row">
                <div class="col-12 col-xl-8">
                    <div class="block">
                        <form method="post" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)" id="updateObject">

                            <div class="alert alert-danger" v-if="error" v-text="error"></div>
                            <div class="alert alert-success" v-if="success" v-text="success"></div>

                            <Selector :options="objectTypes" v-model="form.type" label="Type" :hasError="form.errors.has('type')" v-if="form.inspection_type === 1"/>
                            <Selector :options="selectors.weatherTypes" v-model="form.weather" label="Weersomstandigheden" :hasError="form.errors.has('weather')"/>
                            <Selector :options="selectors.limitations" v-model="form.limited_by" label="Beperkt door" :hasError="form.errors.has('limited_by')" v-if="form.inspection_type === 1" />

                            <ImageUpload type="property" :typeID='parseInt( this.$route.params.propertyID )' :images="this.images"></ImageUpload>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="footer">
            <div class="footer__left">
                <router-link :to="{ name: 'schedule' }" active-class="active" class="btn btn-grey">Terug naar overzicht</router-link>
            </div>

            <div class="footer__right">
                <a @click.prevent="onSkip" class="btn btn-info">Overslaan</a>
                <input type="submit" value="Volgende" class="btn btn-primary" form="updateObject">
            </div>
        </div>
    </div>
</template>

<script>
	import { SET_TAGS } from '@/store/modules/tags'
	import { SET_LOADING } from '@/store/modules/loader'
	import { UPDATE_OBJECT_SILENT, FETCH_OBJECT } from '@/store/modules/objects'
	import { mapGetters } from 'vuex'
	import { SET_MENU_ACTIVE } from '@/store/modules/menu'
	import Form from '@/utilities/Form'
	import Selector from '@/components/global/Selector'
	import ObjectType from '@/utilities/mapping/ObjectType'
	import WeatherTypes from '@/utilities/mapping/WeatherTypes'
	import ObjectLimitations from '@/utilities/mapping/ObjectLimitations'
	import ImageUpload from '@/components/global/ImageUpload'
	import { CREATE_INSPECTION } from '@/store/modules/inspections'
	import { UPDATE_SCHEDULE } from '@/store/modules/schedule'

	export default {
		components: { ImageUpload, Selector },

		data () {
			return {
				inspectionID: null,
				property: {},
				error: null,
				success: null,
				images: [],
				selectors: {
					weatherTypes: WeatherTypes,
					limitations: ObjectLimitations,
				},
				form: new Form({
					inspection_type: 1,
					type: null,
					weather: null,
					limited_by: 'Niet van toepassing',
				}),
			}
		},

		mounted () {
			this.$store.dispatch(SET_MENU_ACTIVE, false)
			this.fetchData()
		},

		computed: {
			objectTypes () {
				return ObjectType.map((type) => {
					return { value: type.text, text: type.text }
				})
			},

			...mapGetters([
				'currentUser',
				'isLoading',
				'isMenuActive',
			]),
		},

		methods: {
			fetchData () {
				this.$store.dispatch(SET_LOADING, true)

				this.$store.dispatch(FETCH_OBJECT, {
					project: this.$route.params.projectID,
					object: this.$route.params.propertyID,
				}).then((response) => {
					this.property = response

					this.form.inspection_type = response.inspection_type
					this.form.type = response.type
					this.images = response.images

					let address = response.street + ' ' + ( response.housenumber ? response.housenumber : '' ) + ( response.housenumber_addition ? response.housenumber_addition : '' )

					this.$store.dispatch(SET_TAGS, [
						response.project.name,
						response.project.file_id,
						address,
					])

					this.$store.dispatch(UPDATE_SCHEDULE, {
						id: this.$route.params.scheduleID,
						changes: {
							status: 2,
						},
					})

					this.$store.dispatch(SET_LOADING, false)
				})
			},

			onSkip () {
				this.$store.dispatch(SET_LOADING, true)

				this.$store.dispatch(CREATE_INSPECTION, {
					property: this.$route.params.propertyID,
					weather: this.form.weather,
					limited_by: this.form.limited_by,
				}).then((response) => {
					this.$router.push({ name: 'inspectionInspect', params: { scheduleID: this.$route.params.scheduleID, projectID: this.$route.params.projectID, propertyID: this.$route.params.propertyID, inspectionID: response.id } })
					this.$store.dispatch(SET_LOADING, false)
				})
			},

			onSubmit () {
				this.$store.dispatch(SET_LOADING, true)

				// Update type of object
				let updateObject = this.$store.dispatch(UPDATE_OBJECT_SILENT, {
					id: this.$route.params.propertyID,
					projectID: this.$route.params.projectID,
					changes: {
						type: this.form.type,
					},
				}).then((response) => {
					console.log('updateObject, then', response)
				}).catch((response) => {
					console.log('updateObject, catch', response)
				})

				// Create a new inspection
				let inspection = this.$store.dispatch(CREATE_INSPECTION, {
					property: this.$route.params.propertyID,
					data: {
						schedule: this.$route.params.scheduleID,
						weather: this.form.weather,
						limited_by: this.form.limited_by,
					},
				}).then((response) => {
					console.log('inspection, then', response)
					this.inspectionID = response.id
				}).catch((response) => {
					console.log('inspection, catch', response)
				})

				Promise.all([updateObject, inspection]).then(() => {
					this.$router.push({ name: 'inspectionInspect', params: { scheduleID: this.$route.params.scheduleID, projectID: this.$route.params.projectID, propertyID: this.$route.params.propertyID, inspectionID: this.inspectionID } })
					this.$store.dispatch(SET_LOADING, false)
				})
			},
		},
	}
</script>